export type SortDirection = "asc" | "desc";

export function filterBySubstring<T>(
  items: readonly T[],
  query: string,
  getValue: (item: T) => string
): T[] {
  const q = query.trim().toLowerCase();
  if (!q) return [...items];

  return items.filter((item) => getValue(item).toLowerCase().includes(q));
}

export function sortByString<T>(
  items: readonly T[],
  getValue: (item: T) => string,
  direction: SortDirection,
  locale: string = "fr"
): T[] {
  const sorted = [...items].sort((a, b) =>
    getValue(a).localeCompare(getValue(b), locale, {
      numeric: true,
      sensitivity: "base",
    })
  );
  return direction === "asc" ? sorted : sorted.reverse();
}

export function filterAndSortByString<T>(
  items: readonly T[],
  params: {
    query: string;
    getValue: (item: T) => string;
    direction: SortDirection;
    locale?: string;
  }
): T[] {
  const filtered = filterBySubstring(items, params.query, params.getValue);
  return sortByString(
    filtered,
    params.getValue,
    params.direction,
    params.locale
  );
}
